import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import userReduser from './userSlice';
import eventReducer from './eventSlice';
import stickerReduser from './stickerSlice';
import categoryReducer from './categorySlice';
import exhibitorReduser from './exhibitorSlice';
import activityReduser from './activitySlice';

export default configureStore({
    reducer: {
        auth: authReducer,
        user: userReduser,
        event: eventReducer,
        sticker: stickerReduser,
        category: categoryReducer,
        exhibitor: exhibitorReduser,
        activity: activityReduser,
    }
});
